<template>
  <v-card class="message-card py-3 px-6" elevation="0">
    <v-row class="d-flex">
      <v-col class="d-flex flex-grow-0 text-end" style="margin: auto">
        <AppkitIcon :icon="icon" size="large" />
      </v-col>
      <v-col class="flex-grow-1">
        <strong>
          <slot name="title"></slot>
        </strong>
        <p>
          <slot></slot>
        </p>
      </v-col>
      <v-col class="flex-grow-0" style="margin: auto">
        <PMessageBoxButton
          @click="click"
          :loading="loading"
          :disabled="disableButton"
        >
          <slot name="buttonText"></slot>
        </PMessageBoxButton>
      </v-col>
    </v-row>
  </v-card>
</template>

<script setup lang="ts">
import AppkitIcon from "@/components/custom/AppkitIcon.vue";
import PMessageBoxButton from "@/components/custom/buttons/PMessageBoxButton.vue";

withDefaults(
  defineProps<{
    icon: string;
    loading: boolean;
    disableButton: boolean;
  }>(),
  {
    loading: false,
    disableButton: false,
  }
);

const emit = defineEmits<{
  (e: "click"): void;
}>();

function click() {
  emit("click");
}
</script>

<style lang="scss" scoped>
.message-card {
  text-align: left;
  background-color: #e7f3ff;
  border: 1px solid #438dc8;
  border-radius: 6px;
}

.message-box-button {
  border: 1px solid var(--dark-grey);
}
</style>
